import { KIOSK_INCLUDED_CONFIG } from "../constants/plans";

export const isOptionDeprecated = (option) => {
  return !option || option.is_deprecated;
}

export const isKioskIncluded = (option) => {
  if(isOptionDeprecated(option)) return false;
  return option.is_kiosk_included;
}

export const isObligatoryOption = (option) => {
  if(!option || option.is_deprecated) return false;
  return option.obligatory;
}

export const isKioskIncludedOption = (option) => {
  if(isOptionDeprecated(option)) return false;
  const kioskList = Object.keys(KIOSK_INCLUDED_CONFIG);
  if(!kioskList.includes(option.key_name)) return false;
  return isKioskIncluded(option) &&  !isObligatoryOption(option);
}